export const ItemTypes = {
    PIC: "pic",
    DRAGS: "drags",
    ONEPOS: "onepos",
    DROPS: "drops",
    BACKS: "backs",
    CARS: "cars",
    TOOL: "tool"
};
